export interface RecentTask { id: string; rootId: string; title: string }

const allowedMobileActions = new Set(["search", "new", "sync", "calendar", "more", "notes"]);
export const defaultMobileActions = ["search", "new", "more", "notes"];

export function normalizeMobileActions(actions: string[], limit = 5): string[] {
  const normalized = [...new Set(actions.filter(action => allowedMobileActions.has(action)))].slice(0, limit);
  return normalized.length ? normalized : [...defaultMobileActions];
}

export function rememberRecentTask(recent: RecentTask[], task: RecentTask, limit = 8): RecentTask[] {
  return [task, ...recent.filter(item => item.id !== task.id)].slice(0, limit);
}

export function toggleFavoriteTask(ids: string[], id: string, limit = 12): string[] {
  return ids.includes(id) ? ids.filter(item => item !== id) : [id, ...ids].slice(0, limit);
}
